import { render, staticRenderFns } from "./BreedCard.vue?vue&type=template&id=547a4cc6&scoped=true&"
import script from "./BreedCard.vue?vue&type=script&lang=ts&"
export * from "./BreedCard.vue?vue&type=script&lang=ts&"
import style0 from "./BreedCard.vue?vue&type=style&index=0&id=547a4cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547a4cc6",
  null
  
)

export default component.exports